import { toast, Slide } from 'react-toastify';

export const showToastInvalid = (
    message: string,
) => {

    toast.warn(
        message,
        {
            position: "bottom-left",
            autoClose: 1500,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            closeButton: false,
            transition: Slide,
            style: {
                fontSize: "16px",
                color: "#000000",
                width: "100%",
                whiteSpace: "nowrap",
                wordBreak: "break-word",
            },
        }
    );
};
